import React from 'react';
import styled from 'styled-components/macro';
import { Link } from 'react-router-dom';

import { fontWeightBold } from 'variables/font';
import { brand, brandLight, grey5, grey70, white } from 'variables/colors';
import { borderRadius } from 'variables/general';

const Root = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  margin: 0.5em 1.5em;
  padding: 0.75em 1em;
  color: ${({ active }) => (active ? brand : grey70)};
  font-size: 16px;
  background-color: ${({ active }) => (active ? brandLight : white)};
  border-radius: ${borderRadius};

  &:hover {
    background-color: ${({ active }) => !active && grey5};
  }

  .custom-icon {
    path {
      fill: ${({ active }) => active && brand};
    }
  }

  ${({ active }) =>
    active &&
    `
      &::before {
        position: absolute;
        top: 0;
        bottom: 0;
        left: -1.5em;
        display: inline-block;
        width: 0.25em;
        height: calc(100% - 0.5em);
        margin: 0.25em 0;
        background-color: ${brand};
        border-top-right-radius: 1em;
        border-bottom-right-radius: 1em;
        content: '';
      }
  `}
`;

const Label = styled.p`
  margin: 0.2em 0 0 1em;
  font-weight: ${fontWeightBold};
`;

const ConditionalLinkWrapper = ({ condition, wrapper, children }) =>
  condition ? wrapper(children) : children;

const LinkItem = ({ active, label, icon, pathname }) => (
  <ConditionalLinkWrapper
    condition={!active}
    wrapper={(children) => <Link to={pathname}>{children}</Link>}
  >
    <Root active={active}>
      {icon}
      <Label>{label}</Label>
    </Root>
  </ConditionalLinkWrapper>
);

export default LinkItem;
